import { useState, useCallback, useEffect } from 'react';
import { notificationAPI } from '../../services/notificationService';
import type { Notification } from '../../types/notification';
import { NotificationStatusEnum } from '../../types/notification';

export const useNotifications = () => {
  const [list, setList] = useState<Notification[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchList = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await notificationAPI.getList();
      setList(Array.isArray(data) ? data : []);
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Erro ao carregar notificações');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const unreadCount = list.filter((n) => n.status === NotificationStatusEnum.UNREAD).length;

  return {
    list,
    unreadCount,
    isLoading,
    error,
    refetch: fetchList,
  };
};
